// Import model
import { StartAiChatUploadImageRequest } from '../models/StartAiChatUploadImageRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartAiChatUploadImageRequest - handles JSON serialization and deserialization with type validation
 */
export class StartAiChatUploadImageRequestSerializer {
  /**
   * Deserializes a JSON string into a StartAiChatUploadImageRequest instance
   */
  static deserialize(json: string): StartAiChatUploadImageRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartAiChatUploadImageRequest instance
   */
  static fromObject(obj: any): StartAiChatUploadImageRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartAiChatUploadImageRequest');
    }


    const instance: StartAiChatUploadImageRequest = {
      fileName: obj['fileName'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartAiChatUploadImageRequest instances
   */
  static deserializeArray(json: string): StartAiChatUploadImageRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartAiChatUploadImageRequest instance to a JSON string
   */
  static serialize(instance: StartAiChatUploadImageRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartAiChatUploadImageRequest instance to a plain object
   */
  static toObject(instance: StartAiChatUploadImageRequest): any {
    return {
      'fileName': instance.fileName,
      'contentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of StartAiChatUploadImageRequest instances to a JSON string
   */
  static serializeArray(instances: StartAiChatUploadImageRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
